













import {Vue, Component} from 'vue-property-decorator';
import {headerPerticlesConfig} from '@/export-helpers/particlesConfigs';
// @ts-ignore
import 'particles.js/particles';

// @ts-ignore
const particlesJS = window.particlesJS;

@Component({
    name: 'ParticlesBlock',
})
export default class ParticlesBlock extends Vue {
    public isParticlesExpanded: boolean = false;

    public mounted() {
        this.startParticles();
    }

    public beforeDestroy(): void {
        // @ts-ignore
        pJSDom = [];
    }

    public toggleExpandParticlesElement() {
        this.isParticlesExpanded = !this.isParticlesExpanded;
        const body = document.querySelector('body') as HTMLElement;

        if (this.isParticlesExpanded) {
            body.style.overflow = 'hidden';
            body.style.position = 'fixed';
        } else {
            body.style.overflow = 'auto';
            body.style.position = 'static';
        }

        this.$nextTick(() => {
            // @ts-ignore
            pJSDom[0].pJS.particles.move.enable = true;
            // @ts-ignore
            pJSDom[0].pJS.fn.particlesRefresh();
        });
    }

    private startParticles() {
        particlesJS('particles-js', headerPerticlesConfig);
    }
}
